import { Configuration, PopupRequest, LogLevel } from '@azure/msal-browser';

const tenantId = process.env.REACT_APP_AZURE_TENANT_ID || '';
const clientId = process.env.REACT_APP_AZURE_CLIENT_ID || '';
const redirectUri = process.env.REACT_APP_AZURE_REDIRECT_URI || window.location.origin;

export const apiScope = process.env.REACT_APP_API_SCOPE || '';

export const msalConfig: Configuration = {
  auth: {
    clientId,
    authority: `https://login.microsoftonline.com/${tenantId}`,
    redirectUri,
    postLogoutRedirectUri: redirectUri,
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        if (level === LogLevel.Error) console.error(message);
      },
      piiLoggingEnabled: false,
      logLevel: LogLevel.Warning,
    },
  },
};

export const loginRequest: PopupRequest = {
  scopes: [apiScope, 'openid', 'profile', 'email'],
};

export const tokenRequest = {
  scopes: [apiScope],
};
